<template>
  <span
    class="clickable ball-icon" 
    :class="iconState.value"
    @click="onBallSelected(ball)">
    <span v-if="iconState.isWicket">W</span>
    <span v-else-if="iconState.isDot">•</span>
    <span v-if="ball.runs">{{ball.runs}}</span>
  </span>
</template>
<script>
import { DataState } from '@/state'
import { Enum } from '@/helpers/enum'

export const IconState = new Enum({
  Dot: 'dot',
  Boundary: 'boundary',
  Wicket: 'wicket',
  Runs: 'runs',
  Extra: 'extra',
})

export default {
  props: {
    ball: Object
  },
  computed: {
    iconState () {
      let extras = 0
      if (this.ball.extras) {
        extras = parseInt(this.ball.extras)
      }

      let state = IconState.Dot
      if (this.ball.batsman.six || this.ball.batsman.four) {
        state = IconState.Boundary
      } else if (this.ball.wicket_type) {
        state = IconState.Wicket
      // } else if (extras !=0 && extras == this.ball.runs) {
      } else if (extras > 0) {
        state = IconState.Extra
      } else if (this.ball.runs > 0) {
        state = IconState.Runs
      }

      return state
    }
  },
  methods: {
    onBallSelected (ball) {
      this.$emit('ballSelected', ball)
    }
  }
}
</script>
